/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineDettaglioUpdateDTO
 */
export interface OrdineDettaglioUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioUpdateDTO
     */
    quantita?: number;
}

/**
 * Check if a given object implements the OrdineDettaglioUpdateDTO interface.
 */
export function instanceOfOrdineDettaglioUpdateDTO(value: object): value is OrdineDettaglioUpdateDTO {
    return true;
}

export function OrdineDettaglioUpdateDTOFromJSON(json: any): OrdineDettaglioUpdateDTO {
    return OrdineDettaglioUpdateDTOFromJSONTyped(json, false);
}

export function OrdineDettaglioUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineDettaglioUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'quantita': json['quantita'] == null ? undefined : json['quantita'],
    };
}

  export function OrdineDettaglioUpdateDTOToJSON(json: any): OrdineDettaglioUpdateDTO {
      return OrdineDettaglioUpdateDTOToJSONTyped(json, false);
  }

  export function OrdineDettaglioUpdateDTOToJSONTyped(value?: OrdineDettaglioUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantita': value['quantita'],
    };
}

